import { IBookingOnlineNewCustomer } from 'pages/reservationBookingOnlineV2/pages/StepConfirmationOfReservationDetail/types';
import {
  IAvailableReservationBooking, ICMInfo, IHeadQuarterData, IReservationSearchBookingOnline, IStoreSettingDetail,
} from 'pages/reservationBookingOnlineV2/pages/StepDateAndTimeVisitSelection/types';
import {
  IDesiredService, TDesiredCareParam, TDesiredCourseParam, TDesiredAreaParam, TDesiredCare, TDesiredArea,
  TDesiredStoreParam, TDesiredCourse, TDesiredStore, TCourseCode, TPointCourseCode, NeighborhoodStores, TDetailOnlineStoreParam, TDetailOnlineStore,
} from 'pages/reservationBookingOnlineV2/pages/StepsBeforeReservation/types';
import ApiClient from './ApiClient';

// 企業ロゴURL
export const getCompanyLogosApi = async (companyCode: string): Promise<string[]> => {
  const { data } = await ApiClient.get('/v1/companyLogos', { companyCode });
  return data;
};

// ご希望のサービス
export const getDesiredServiceApi = async (companyCode: string, includeHidden?: boolean): Promise<IDesiredService[]> => {
  const { data } = await ApiClient.get('/v1/reservationNewClients/getClassType', { companyCode, ...(includeHidden ? { includeHidden: 'true' } : {}) });
  return data;
};

// ご希望のお手入れ
export const getDesiredCareApi = async (params: TDesiredCareParam): Promise<TDesiredCare[]> => {
  const { data } = await ApiClient.get('/v1/contractCourseCategories/newClient/getByClassType', {}, params);
  return data;
};

// ご希望のコース
export const getDesiredCourseApi = async (params: TDesiredCourseParam): Promise<TDesiredCourse[]> => {
  const { data } = await ApiClient.get('/v1/contractCourseMsts/newClient/getContractCourseMst', {}, params);
  return data;
};

// ご希望のエリア
export const getDesiredAreaApi = async (params: TDesiredAreaParam): Promise<TDesiredArea[]> => {
  const { data } = await ApiClient.get('/v1/areaMasters/newClient/getAreaOnline', {}, params);
  return data;
};

// ご希望のエリア（既存客／予約変更フロー用）
export const getDesiredAreaExistingClientApi = async (params: TDesiredAreaParam): Promise<TDesiredArea[]> => {
  const { data } = await ApiClient.get('/v1/areaMasters/existingClient/getAreaOnline', {}, params);
  return data;
};

// ご希望の店舗
export const getDesiredStoreApi = async (params: TDesiredStoreParam): Promise<TDesiredStore[]> => {
  const { data } = await ApiClient.get('/v1/organizations/newClient/getOrganizationOnline', {}, params);
  return data;
};

// ご希望の店舗（既存客／予約変更フロー用）
export const getDesiredStoreExistingClientApi = async (params: TDesiredStoreParam): Promise<TDesiredStore[]> => {
  const { data } = await ApiClient.get('/v1/organizations/existingClient/getOrganizationOnline', {}, params);
  return data;
};

export const getDetailOnlineStoreApi = async (params: TDetailOnlineStoreParam): Promise<TDetailOnlineStore> => {
  const { data } = await ApiClient.get('/v1/organization/newClient/getOrganizationDetailOnline', {}, params);
  return data;
};


export const getCurrentCourseCodeApi = async (params: TCourseCode): Promise<TPointCourseCode> => {
  const { data } = await ApiClient.get('/v1/contractCourseMsts/newClient/getContractCourseMstByCourseCode', {}, params);
  return data;
};


export const getNeighborhoodStoresApi = async (params: { companyCode:string, choosingOrgId: string, contractCourseMstId: string}): Promise<NeighborhoodStores[]> => {
  const { data } = await ApiClient.get('/v1/organizations/bookingOnline/getNeighborhoodStores', {}, params);
  return data;
};

//
export const getAvailableReservationForNewClientsBookingOnlineApi = async (params: IReservationSearchBookingOnline): Promise<IAvailableReservationBooking[]> => {
  const { data } = await ApiClient.get('/v1/reservations/bookingOnline/availableReservationForNewClients', params);
  return data;
};


export const getHeadQuarterApi = async (companyCode:string): Promise<IHeadQuarterData> => {
  const { data } = await ApiClient.get(`/v1/reservationHeadquartersSettings/${companyCode}`, {});
  return data;
};

export const getStoreSettingDetailApi = async (params: { orgId: string, companyCode: string}): Promise<IStoreSettingDetail> => {
  const { data } = await ApiClient.get('/v1/reservation/storeSetting', params);
  return data;
};

export const getCMInfoApi = async (companyCode:string): Promise<ICMInfo[]> => {
  const { data } = await ApiClient.get('/v1/reservationCmInfo', { companyCode });
  return data;
};


export const postOnlineReservationsNewCustomer = async (params: IBookingOnlineNewCustomer, mediaCode?:string, trackingCode?:string): Promise<any> => {
  const query: Record<string, string> = {};
  if (mediaCode) query.mediaCode = mediaCode;
  if (trackingCode) query.trackingCode = trackingCode;
  const { data } = await ApiClient.postJsonData('/v2/onlineReservations/newCustomer', query, params);
  return data;
};

// 効果測定URL（trackingCode）経由の予約ページ表示を計測する（公開・認証不要）
export const trackReservationClickApi = async (companyCode: string, trackingCode: string): Promise<void> => {
  await ApiClient.postJsonData('/v1/tracking/click', { companyCode, trackingCode }, {});
};


export const sentMailReservationV2Api = async (params:{companyCode:string, reservationId:string, customerType:string}) => {
  const { data } = await ApiClient.postJsonData('/v2/onlineReservations/sendMail', {}, params);
  return data;
};

export const sentMailContactV2Api = async (params:{companyCode:string, reservationId:string, customerType:string}) => {
  const { data } = await ApiClient.postJsonData('/v2/onlineReservations/sendMailContact', {}, params);
  return data;
};


export const getStoreSettingStartTimeAndEndTimeApi = async (params: { orgId: string, targetDate: string, companyCode: string, contractCourseId?: string}) => {
  const { data } = await ApiClient.get('/v1/reservation/storeSetting/startTimeAndEndTimeForOnline', params);
  return data;
};
